// extracted by mini-css-extract-plugin
module.exports = {"cards":"ccfda6eb9f--cards--nMZHh","card":"ccfda6eb9f--card--fTC7b","img":"ccfda6eb9f--img--WLeX8","text":"ccfda6eb9f--text--dLNT4","rate":"ccfda6eb9f--rate--fg18n"};